import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => {
    return {
        quizRowContainer: {
            overflowY: 'scroll',
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: 14,
            alignItems: 'center',
        },
        quizRow: {
            width: '100%',
            marginTop: 'auto',
            marginBottom: 'auto',
        },
        colorItem: {
            width: '100%',
            height: '100%',
            minHeight: 82,
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            cursor: 'pointer',
            boxSizing: 'border-box',
            position: 'relative',
            '@media (max-height: 695px)': {
                minHeight: 50,
            },
        },
        buttonContinue: {
            color: 'white',
            textDecoration: 'none',
            textTransform: 'none',
        },
        wrapperItem: {},
        itemTitle: {
            fontFamily: 'PoppinsRegular',
            padding: 0,
            fontSize: 16,
            letterSpacing: -0.75,
            marginTop: 4,
            margin: 0,
        },
        itemSubTitle: {
            margin: 0,
            padding: 0,
            fontSize: 16,
            color: theme.palette.grey[300],
            letterSpacing: -0.5,
        },
    };
});
